export default {
  language: '语言',
  addMultiLang: '添加多语言',
  delete: '删除',
  save: '保存',
  addMultiLangModalTitle: '会员多语言信息',
  deleteMultiLangModalTitle: '删除多语言',
  selectLangWarning: '请至少选择一种语言',
  addLangSuccess: '添加语言成功',
  deleteLangSuccess: '删除语言成功',
  deleteLangFailed: '删除语言失败',
  contentRequired: '请输入售后反馈内容',
  saveSuccess: '保存成功',
  saveFailed: '保存失败',
  loadFailed: '加载售后反馈内容失败',
  placeholder: '请输入售后反馈内容',
};
